import get from 'lodash.get';
import { emptyObject } from 'ui-components/default-props/empty';
import { LogService } from '../services/log-service';

class ShipmentStatusServiceClass {
  // since the ShipmentStatusPropTypes has things like marketPlaceNotification it makes more sense for this thing to evolve
  // and not be document-senctric
  buildStatusFromFulfillments(fulfillmentPlan, fulfillments) {
    const packingSlipPrintedStatus = get(fulfillmentPlan, 'packingSlipPrintedStatus', emptyObject);
    const isPackingSlipPrinted = get(fulfillmentPlan, 'packingSlipPrintedStatus.isPrinted', false);
    const packingSlipModifiedDate = get(fulfillmentPlan, 'packingSlipPrintedStatus.modifiedDateTime', undefined);
    const packingSlipPrinted = isPackingSlipPrinted ? { date: packingSlipModifiedDate } : undefined;

    const fulfillment = fulfillments
      .filter((f) => f.fulfillmentPlanId === fulfillmentPlan.fulfillmentPlanId && !f.isLabelVoided)
      .find((f) => !!f.fulfillmentId);

    const labelCreatedDateTime = get(fulfillment, 'labelCreatedDateTime', null);
    const labelCreated = labelCreatedDateTime !== null ? { isPrinted: true, date: labelCreatedDateTime } : undefined;

    const labelPrintedStatus = get(fulfillment, 'labelPrintedStatus', {
      isPrinted: false,
    });
    const labelPrinted = labelPrintedStatus && labelPrintedStatus.isPrinted ? { date: labelPrintedStatus.modifiedDateTime } : undefined;

    // on these next three, expect to return the date instead of isPrinted in the future
    const marketplaceStatus = get(fulfillment, 'marketplaceNotification.status', 'NotNotified');
    const marketplaceNotified = marketplaceStatus === 'Notified' ? { isPrinted: true } : undefined;

    const shipmentEmailStatus = get(fulfillment, 'shipmentEmailNotification.status', 'NotSent');
    const shipmentEmailSent = shipmentEmailStatus === 'Sent' ? { isPrinted: true } : undefined;

    const deliveryEmailStatus = get(fulfillment, 'deliveryEmailNotification.status', 'NotSent');
    const deliveryEmailSent = deliveryEmailStatus === 'Sent' ? { isPrinted: true } : undefined;
    const marketplaceNotification = this.mapNotificationErrorMessage(get(fulfillment, 'marketplaceNotification', emptyObject));
    const shipmentEmailNotification = this.mapNotificationErrorMessage(get(fulfillment, 'shipmentEmailNotification', emptyObject));
    const deliveryEmailNotification = this.mapNotificationErrorMessage(get(fulfillment, 'deliveryEmailNotification', emptyObject));

    return {
      packingSlipPrinted,
      packingSlipPrintedStatus,
      labelCreated,
      labelPrinted,
      labelPrintedStatus,
      labelCreatedDateTime,
      marketplaceNotified,
      shipmentEmailSent,
      deliveryEmailSent,
      marketplaceNotification,
      shipmentEmailNotification,
      deliveryEmailNotification,
    };
  }

  mapNotificationErrorMessage(notification) {
    let errorMessage = get(notification, 'errorMessage');
    if (!errorMessage) {
      return notification;
    }

    // TODO: This could have a slightly improved check to see if the string is at least starting with valid JSON before we try to parse it.
    if (typeof errorMessage === 'string') {
      let parsed;
      try {
        parsed = JSON.parse(errorMessage);
        errorMessage = parsed.message;
      } catch (error) {
        // TODO: should we even log these failures? or do anything on the catch here?
        const message = 'Failed attempt to parse the notification error message as JSON in the shipment status service.';
        LogService.logInfo(message, error);
      }
    }
    return {
      ...notification,
      errorMessage,
    };
  }
}

export const ShipmentStatusService = new ShipmentStatusServiceClass();
